<template>
	<div>
		<div class="container-fluid mt-4">
			<nav class="navbar navbar-expand-lg navbar-light">
			 	<h1 class="h3 mb-0 text-gray-800 mr-4 mb-2">
					Relatórios - Pedidos
			  	</h1>
			  	<button 
					class="navbar-toggler" 
					type="button" 
					data-toggle="collapse" 
					data-target="#navbarSupportedContent" 
					aria-controls="navbarSupportedContent" 
					aria-expanded="false" 
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse mt-4" id="navbarSupportedContent">
			  		<div class="form-row">
						<div class="form-group col-md-12">
							<input-date 
								time="1000"
								@date="setDate">
							</input-date>
						</div>
					</div>
			  	</div>
			</nav>
			<relatorio-pedido-totais
				v-if="date"
				:key="relatorioPedidoTotaisKey"
				:date="date">
			</relatorio-pedido-totais>
			<relatorio-pedido-medias
				v-if="date"
				:key="relatorioPedidoMediasKey"
				:date="date">
			</relatorio-pedido-medias>
			<relatorio-pedido-datas
				v-if="date"
				:key="relatorioPedidoDataKey"
				:date="date">
			</relatorio-pedido-datas>
			<relatorio-pedido-totais-chart
				v-if="date"
				:key="relatorioPedidoTotaisChartKey"
				:date="date">
			</relatorio-pedido-totais-chart>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				date: '',
				relatorioPedidoTotaisKey: 1,
				relatorioPedidoMediasKey: 2,
				relatorioPedidoDataKey: 3,
				relatorioPedidoTotaisChartKey: 4
			}
		},
		methods: {
			setDate(date){
				this.date = date;
				this.reload();
			},
			reload(){
				this.relatorioPedidoTotaisKey += 1;
				this.relatorioPedidoMediasKey += 1;
				this.relatorioPedidoDataKey += 1;
				this.relatorioPedidoTotaisChartKey += 1;
			}
		}
	}
</script>